/*
	STATE
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import fileSystem from './programs/core/fileSystem/';
import windowManager from './windowManager/';

//------------------------------------------------------------
// SYSTEM STATE
//------------------------------------------------------------

const state = {
	// firstRun: false, // will be true forever after preloading
	fullscreen: false,
	showSystem: true, // false for starting with basement

	// SYSTEM THEMES

	systemThemes: {
		'theme-95': false,
		'theme-98': true,
		'theme-xp': false,
		'theme-os': false
	}
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,

	modules: {
		fileSystem,
		windowManager
	}
}
//===========================================
//
//===========================================